import { MUTATION_SET_TRANSACTIONS, MUTATION_SET_IRA_INFLOW_OUTFLOW_TRANSACTIONS } from "./types";
import { mapTransactionsDtoToModel, mapIraTransactionsDtoToModel } from "@/services/mappers/transactions/transactions-mappers";

export default {
    [MUTATION_SET_TRANSACTIONS]: async (state, {transactions, providerLookups}) => {
        state.transactions = (transactions?.data || []).map((transaction) => mapTransactionsDtoToModel(transaction, providerLookups));
    },
    [MUTATION_SET_IRA_INFLOW_OUTFLOW_TRANSACTIONS]: async (state, {transactions, providerLookups}) => {
        state.iraInflowOutflowTransactions = (transactions || []).map((transaction) => mapIraTransactionsDtoToModel(transaction, providerLookups));
    }
}